import { IEditableUserData, UserSettingsPayload } from '@/redux/user/types'
import { UserRole } from '@/types'
import { httpClient } from './httpClient'

interface EditUserDataPayload {
  roles: UserRole[]
  fieldsToEdit: Partial<IEditableUserData>
}

export async function getUserDataByEmail ({ email }: { email: string }) {
  try {
    let url = import.meta.env.VITE_GET_USER_DATA_BY_EMAIL
    url = url.replace('__email__', email)

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'GET',
      suppressErrorNotification: true,
      cache: false
    })

    if (!response?.data) return null

    return response.data
  } catch (error) {
    console.error('getUserDataByEmail - Error: ', error)

    return null
  }
}

export async function editUserData ({
  roles,
  fieldsToEdit
}: EditUserDataPayload) {
  try {
    const response = await httpClient({
      baseURL: roles.includes('doctor')
        ? import.meta.env.VITE_API_MAIN_BASEURL
        : import.meta.env.VITE_API_PATIENT_BASEURL,
      url: import.meta.env.VITE_EDIT_USER_DATA_ENDPOINT,
      withCredentials: true,
      method: 'PUT',
      data: fieldsToEdit
    })

    if (!response?.data) return null

    return response.data
  } catch (error) {
    console.error('editUserData - Error: ', error)

    return null
  }
}

export async function editUserSettings ({
  roles,
  userSettingsToEdit
}: {
  roles: UserRole[]
  userSettingsToEdit: Partial<UserSettingsPayload>
}) {
  try {
    const response = await httpClient({
      baseURL: roles.includes('doctor')
        ? import.meta.env.VITE_API_MAIN_BASEURL
        : import.meta.env.VITE_API_PATIENT_BASEURL,
      url: import.meta.env.VITE_EDIT_USER_SETTINGS_ENDPOINT,
      withCredentials: true,
      method: 'PUT',
      data: userSettingsToEdit
    })

    if (!response?.data) return null

    return response?.data
  } catch (error) {
    console.error('editUserSettings - Error: ', error)
    throw error
  }
}

export async function deleteMyAccount ({ roles } : {roles: UserRole[]}) {
  try {
    const url = import.meta.env.VITE_DELETE_ACCOUNT_ENDPOINT

    const response = await httpClient({
      baseURL: roles.includes('doctor')
        ? import.meta.env.VITE_API_MAIN_BASEURL
        : import.meta.env.VITE_API_PATIENT_BASEURL,
      url,
      withCredentials: true,
      method: 'DELETE'
    })

    return response
  } catch (error) {
    console.error('deleteMyAccount - Error: ', error)
    throw error
  }
}
